import { GoogleGenerativeAI } from "@google/generative-ai";
import { GEMINI_MODEL } from "./config.js";

const genAI = new GoogleGenerativeAI("AIzaSyAeNIUMLrxZDpHKnBdpzsk5DM0FnxJ1-WE");


function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}


export async function getUserLocationString() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return resolve("Canada"); // Fallback
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        console.log(latitude, "ll")
        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
          );
          const data = await response.json();

          const city = data.address.city || data.address.town || data.address.village || "";
          const state = data.address.state || data.address.province || "";
          const locationString = `${city}, ${state}`.trim();

          resolve(locationString || "Canada");
        } catch (error) {
          console.error("Failed to reverse geocode:", error);
          resolve("Canada");
        }
      },
      (err) => {
        console.warn("Geolocation error:", err.message);
        resolve("Canada");
      }
    );
  });
}


export async function extractDataFromFile(file) {
  try {
    const base64Data = await toBase64(file);

    const model = genAI.getGenerativeModel({ model: GEMINI_MODEL });
    const userLocation = await getUserLocationString();

    console.log(userLocation, "your locations")



    //     const prompt = `
    // Extract the following structured data from the attached bill image and return in **pure JSON format**. Do not use markdown.

    // Also include **cheapest alternative recommendations** for each item based on stores near "${userLocation}".

    // Return the following JSON structure exactly:

    // {
    //   "supplier_name": "",
    //   "supplier_city": "",
    //   "supplier_address": "",
    //   "supplier_phone": "",
    //   "receipt_date": "YYYY-MM-DD",
    //   "bill_id": "",
    //   "total_tax_amount": 0.0,
    //   "net_amount": 0.0,
    //   "total_amount": 0.0,
    //   "currency": "",
    //   "payment_type": "",
    //   "credit_card_last4": "",
    //   "line_items": [
    //     { "item": "", "price": 0.0 }
    //   ],
    //   "recommendations": [
    //     {
    //       "item": "",
    //       "recommended_price": 0.0,
    //       "store_name": "",
    //       "store_address": "",
    //     }
    //   ]
    // }

    // Guidelines:
    // - **bill_id** (bill/invoice/transaction number/barcode or QR code number) must be extracted if present. If not visible, return an empty string.
    // - The **date** should be extracted from the bill and returned in **YYYY-MM-DD format**.
    // - If the bill has no date, return an empty string.
    // - Use dot-decimal format for all numeric values (e.g., 2.47 not 2,47).
    // - Use realistic pricing and common nearby stores (e.g., Walmart, No Frills, Costco) for recommendations near "${userLocation}".
    // - If any field is missing or unreadable, return an empty string or zero.
    // - Respond with strictly valid JSON. No markdown, no formatting, no extra explanation.
    // `


    //     const prompt = `
    // Extract structured data from the attached bill image and return as pure JSON. Do NOT include any markdown or explanation.

    // Also include cheapest alternative recommendations for each item based on stores near "${userLocation}".

    // Use the following JSON format:

    // {
    //   "supplier_name": "",
    //   "supplier_city": "",
    //   "supplier_address": "",
    //   "supplier_phone": "",
    //   "receipt_date": "YYYY-MM-DD",
    //   "bill_id": "",
    //   "total_tax_amount": 0.0,
    //   "net_amount": 0.0,
    //   "total_amount": 0.0,
    //   "currency": "",
    //   "payment_type": "",
    //   "credit_card_last4": "",
    //   "line_items": [
    //     { "item": "", "price": 0.0 }
    //   ],
    //   "recommendations": [
    //     {
    //       "item": "",
    //       "actual_price": 0.0,
    //       "recommended_price": 0.0,
    //       "store_name": "",
    //       "store_address": "",
    //       "estimated_savings": 0.0
    //     }
    //   ],
    //   "total_savings": 0.0
    // }

    // Guidelines:
    // - Extract item names and prices from the bill.
    // - "bill_id" must be extracted if present (invoice/bill number/barcode).
    // - "receipt_date" must be in "YYYY-MM-DD" format.
    // - For each recommendation:
    //   - Match the original item name.
    //   - Include the actual price from the bill (original).
    //   - Recommend a cheaper price if possible.
    //   - Show the store name and address.
    //   - Calculate estimated savings = actual - recommended.
    // - Sum all estimated savings to compute "total_savings".
    // - Use dot-decimal format (e.g. 2.99).
    // - Use realistic pricing and common nearby stores (e.g., Walmart, No Frills, Costco) for recommendations near "${userLocation}".
    // - If a field is missing, return an empty string or 0.
    // - Return only valid JSON — no markdown or code fences.
    // `;

    const prompt = `
Extract structured data from the attached bill image and return as pure JSON. Do NOT include any markdown or explanation.

Also include cheapest alternative recommendations for each item based on stores near "${userLocation}".

Use the following JSON format:

{
  "supplier_name": "",
  "supplier_city": "",
  "supplier_address": "",
  "supplier_phone": "",
  "receipt_date": "YYYY-MM-DD",
  "bill_id": "",
  "total_tax_amount": 0.0,
  "net_amount": 0.0,
  "total_amount": 0.0,
  "currency": "",
  "payment_type": "",
  "credit_card_last4": "",
  "line_items": [
    { "item": "", "price": 0.0 }
  ],
  "recommendations": [
    {
      "item": "",
      "actual_price": 0.0,
      "recommended_price": 0.0,
      "store_name": "",
      "store_address": "",
      "estimated_savings": 0.0
    }
  ],
  "total_savings": 0.0
}

Guidelines:
- Extract all available fields from the bill, especially item names and prices.
- ALL STRING VALUES (including supplier name, city, address, phone, bill_id, payment type, currency, item names, store names, and store addresses) MUST BE IN UPPERCASE.
- "bill_id" must always be extracted — from barcode, QR code, invoice number, or any unique identifier on the bill. Do not return null or empty — use any clear number or code available.
- "receipt_date" must be in "YYYY-MM-DD" format.
- For each recommendation:
  - Match the original item name.
  - Include the actual price from the bill (original).
  - Recommend a cheaper price if possible.
  - Show the store name and address.
  - Calculate estimated savings = actual - recommended.
- Sum all estimated savings to compute "total_savings".
- Use dot-decimal format for all numeric values (e.g. 2.99).
- Use realistic pricing and common nearby stores (e.g., Walmart, No Frills, Costco) for recommendations near "${userLocation}".
- If a field is missing or unreadable, return an empty string or 0.
- Return only valid JSON — no markdown or code fences.
`;


    const result = await model.generateContent([
      {
        inlineData: {
          data: base64Data.replace(/^data:.*;base64,/, ""),
          mimeType: file.type,
        },
      },
      {
        text: prompt,
      },
    ]);

    const rawText = await result.response.text();

    const cleaned = rawText
      .replace(/^```json/, "")
      .replace(/^```/, "")
      .replace(/```$/, "")
      .trim();

    const parsed = JSON.parse(cleaned);
    return parsed;

  } catch (error) {
    console.error("Error extracting data from file:", error);
    throw error;
  }
}
